// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"77":"f73945669f894f20f4ea","96":"c8f3a0065fad6dcf3083","618":"c398e18871df60670cb7"}[chunkId] + ".js";
};